import { Component, Input, OnInit } from '@angular/core';
import { ContentService, DcrKeyPipe } from '@blk/cwp-ng-framework';
import { InjectConfig, ModelsExperienceConfigKey } from '@ddt-web/config-layer';
import { CellUtil, ComponentData } from '@ddt-web/data-service';
import * as get from 'lodash/get';

@Component({
	selector: 'mb-commentary-text',
	templateUrl: './commentary-text.component.html',
	styleUrls: ['./commentary-text.component.scss']
})
export class CommentaryTextComponent implements OnInit {
	@InjectConfig(ModelsExperienceConfigKey.ENABLE_COMMENTARY_KEYS_MAPPING) private readonly enableCommentaryKeysMapping: boolean = false;

	@Input() public data: ComponentData;
	public commentaryText: string;

	constructor(private contentService: ContentService) { }

	public ngOnInit(): void {
		if (this.data.success && !get(this.data.getTabById('family.commentary'), 'error')) {
			const cells = get(this.data.getTabById('family.commentary'), 'tableData[0].cells', []);
			this.commentaryText = CellUtil.getFormattedCellValueById(cells[0], 'commentaryTypeRef').toString();
			if (this.enableCommentaryKeysMapping) {
				const dcrKeyPipe = new DcrKeyPipe();
				const commentaryCell = CellUtil.getById(cells[0], 'commentaryTypeRef');
				const keyTakeawaysKey = dcrKeyPipe.transform(commentaryCell?.['rawValue'] + '_KEY_TAKEAWAYS');
				const tradeRationaleKey = dcrKeyPipe.transform(commentaryCell?.['rawValue'] + '_TRADE_RATIONALE');
				this.commentaryText = this.contentService.get(keyTakeawaysKey, '') +
					this.contentService.get(tradeRationaleKey, '');
			}
		}
	}

}
